import common from "../common";
import Fighter from "../game/Fighter";
import HealthBar from "../game/HealthBar";
import Projectile from "../game/Projectile";
import isMobile from "ismobilejs";

export default class TutorialWindow extends PIXI.Container
{
    constructor(scene, characterData, width, height)
    {
        super();
        
        this.scene = scene;
        this.signalListeners = scene.signalListeners;
        this.characterData = characterData;
        this.maskWidth = width;
        this.maskHeight = height;
        this.fighter = null;
        this.projectiles = [];

        this.projectileUnderLayer = null;

        this.virtualStick = null;
        this.projectilePool = null;

        this.field = null;

        this.started = true;
        this.completed = false;
        this.fighters = [];

        this.virtualStick = null;
        this.fireButton = null;

        this.arrowKeys = null;
        this.fireKey = null;

        this.pressingFire = false;

        this.lastX = 0;
        this.lastY = 0;

        this.init();
    }

    init()
    {
        var tableOffset = 100;
        this.holder = common.display.container({parent:this});
        common.display.sprite({asset:'bg_gameplay', anchorX:0.5, anchorY:1, y:this.maskHeight/2, parent:this.holder});
        common.display.sprite({asset:'middle_tables', anchorY:0.9, x:(this.maskWidth/2) - tableOffset, y:this.maskHeight/2, parent:this.holder});
        this.holder.mask = common.display.rectangle({rect:{x:-this.maskWidth/2, y:-this.maskHeight/2, width:this.maskWidth, height:this.maskHeight}, fillColour:0x000000, parent:this});

        this.projectileUnderLayer = common.display.container({parent:this.holder});

        this.field = {x:-this.maskWidth/2, y:-this.maskHeight/2, width:this.maskWidth - tableOffset, height:this.maskHeight, direction:1};

        this.fighter = new Fighter(this, 0, this.characterData, Fighter.CONTROL_AI_TUTORIAL, this.field, new HealthBar(), true);
        this.fighter.deactivated = false;
        this.scene.signalListeners.push(this.fighter.signals.fireWeapon.add(this.fireProjectiles, this));
        this.holder.addChild(this.fighter);

        this.projectilePool = new P3.utils.ObjectPool(Projectile, 10);

        if(isMobile(window.navigator).any)
        {
            this.virtualStick = {
                base: common.display.sprite({asset:'btn_move_area', anchor:0.5, parent:this})
            };
            this.virtualStick.stick = common.display.sprite({asset:'btn_move_out', anchor:0.5, parent:this.virtualStick.base});
            this.virtualStick.base.x = -(this.maskWidth/2) + (this.virtualStick.base.width/2) + 20;
            this.virtualStick.base.y = (this.maskHeight/2) - (this.virtualStick.base.height/2) - 20;
            this.virtualStick.base.radius = this.virtualStick.base.width / 2;
            this.virtualStick.stick.radius = this.virtualStick.stick.width / 2;

            this.fireButton = common.display.sprite({asset:'btn_primary_large_out', x:(this.maskWidth/2) - 100, y:(this.maskHeight/2) - 100, anchor:0.5, parent:this});
            common.display.sprite({asset:'icon_splat', anchor:0.5, parent:this.fireButton});
        }
        else
        {
            var buttonSize = 80;
            var margin = 6;
            this.arrowKeys = common.display.container({x:(this.maskWidth/2) - 150, y:(this.maskHeight/2) - 100, parent:this});
            this.arrowKeys.up = common.display.sprite({asset:'btn_key_up_down', x:0, y:-buttonSize-margin, anchor:0.5, parent:this.arrowKeys});
            this.arrowKeys.down = common.display.sprite({asset:'btn_key_down_down', x:0, y:0, anchor:0.5, parent:this.arrowKeys});
            this.arrowKeys.left = common.display.sprite({asset:'btn_key_left_down', x:-buttonSize-margin, y:0, anchor:0.5, parent:this.arrowKeys});
            this.arrowKeys.right = common.display.sprite({asset:'btn_key_right_down', x:buttonSize+margin, y:0, anchor:0.5, parent:this.arrowKeys});
            this.fireKey = common.display.sprite({asset:'btn_spacebar_down', x:(-this.maskWidth/2)+150, y:(this.maskHeight/2)-100, anchor:0.5, parent:this});

            /*this.arrowKeys.up = common.display.rectangle({x:0, y:-buttonSize-margin, rect:{x:-halfSize, y:-halfSize, width:buttonSize, height:buttonSize}, fillColour:0xfa303f, parent:this.arrowKeys});
            this.arrowKeys.down = common.display.rectangle({x:0, y:0, rect:{x:-halfSize, y:-halfSize, width:buttonSize, height:buttonSize}, fillColour:0xfa303f, parent:this.arrowKeys});
            this.arrowKeys.left = common.display.rectangle({x:-buttonSize-margin, y:0, rect:{x:-halfSize, y:-halfSize, width:buttonSize, height:buttonSize}, fillColour:0xfa303f, parent:this.arrowKeys});
            this.arrowKeys.right = common.display.rectangle({x:buttonSize+margin, y:0, rect:{x:-halfSize, y:-halfSize, width:buttonSize, height:buttonSize}, fillColour:0xfa303f, parent:this.arrowKeys});
            this.fireKey = common.display.rectangle({x:(-this.maskWidth/2)+150, y:(this.maskHeight/2)-100, rect:{x:-buttonSize * 2.5, y:-halfSize, width:buttonSize * 5, height:buttonSize}, fillColour:0xfa303f, parent:this});
            */
        }

    }

    destroy()
    { 
        
    }

    update()
    {
        this.fighter.update();

        if(isMobile(window.navigator).any)
        {
            //var angle = Math.atan2(this.fighter.movement.x, this.fighter.movement.y);
            var targetX = this.fighter.control.movement.x * (this.virtualStick.base.radius - this.virtualStick.stick.radius); 
            var targetY = this.fighter.control.movement.y * (this.virtualStick.base.radius - this.virtualStick.stick.radius); 
            
            this.virtualStick.stick.x += (targetX - this.virtualStick.stick.x) / 10;
            this.virtualStick.stick.y += (targetY - this.virtualStick.stick.y) / 10;

            if(!this.fighter.nextProjectileShow && !this.pressingFire)
            {
                this.pressingFire = true;
                this.fireButton.texture = P3.assets.texture('btn_primary_large_down');
                this.fireButton.scale.set(1);
                TweenMax.killTweensOf(this.fireButton.scale);
                TweenMax.to(this.fireButton.scale, .5, {x:0.8, y:0.8, ease:Elastic.easeOut});
            }
            else if(this.fighter.nextProjectileShow && this.pressingFire)
            {
                this.pressingFire = false;
                this.fireButton.texture = P3.assets.texture('btn_primary_large_out');
                this.fireButton.scale.set(0.8);
                TweenMax.killTweensOf(this.fireButton.scale);
                TweenMax.to(this.fireButton.scale, .5, {x:1, y:1, ease:Elastic.easeOut});
            }
        }
        else
        {
            var threshold = 2;

            if(this.fighter.y - this.lastY < -threshold)
                this.arrowKeys.up.texture = P3.assets.texture('btn_key_up_out');
            else
                this.arrowKeys.up.texture = P3.assets.texture('btn_key_up_down');

            if(this.fighter.y - this.lastY > threshold)
                this.arrowKeys.down.texture = P3.assets.texture('btn_key_down_out');
            else
                this.arrowKeys.down.texture = P3.assets.texture('btn_key_down_down');

            if(this.fighter.x - this.lastX < -threshold)
                this.arrowKeys.left.texture = P3.assets.texture('btn_key_left_out');
            else
                this.arrowKeys.left.texture = P3.assets.texture('btn_key_left_down');

            if(this.fighter.x - this.lastX > threshold)
                this.arrowKeys.right.texture = P3.assets.texture('btn_key_right_out');
            else
                this.arrowKeys.right.texture = P3.assets.texture('btn_key_right_down');

            if(!this.fighter.nextProjectileShow && !this.pressingFire)
            {
                this.pressingFire = true;
                this.fireKey.texture = P3.assets.texture('btn_spacebar_out');
            }
            else if(this.fighter.nextProjectileShow && this.pressingFire)
            {
                this.pressingFire = false;
                this.fireKey.texture = P3.assets.texture('btn_spacebar_down');
            }
        }

        this.lastX = this.fighter.x;
        this.lastY = this.fighter.y;

        if(Math.random() > 0.97)
        {
            this.fighter.control.signals.fireProjectile.dispatch();
        }

        for(var i = this.projectiles.length-1; i >= 0; i--)
        {
            var p = this.projectiles[i];

            if(p.canRemove)
            {
                this.projectilePool.free(p);
                this.projectiles.splice(i, 1);
                continue;
            }

            p.update();
            if(p.weight > 0 && p.y > p.groundLevel)
            {
                p.splat();
            }
            else
            {       
                if( p.x > this.field.x + this.field.width + 200 || p.x < this.field.x )
                {
                    p.splat();
                    break;
                }

                if(p.weight == 0 && p.y < this.field.y)
                {
                    p.splat();
                    break;
                }
            }
        }
    }

    fireProjectiles(fighter, pData, p, pImage)
    {
        var randomValue = (arr, integer) => {
            
            if(integer)
            {
                return arr.length > 1 ? P3.math.randomInt(arr[0], arr[1]) : arr[0];
            }
            else
            {
                return arr.length > 1 ? P3.math.random(arr[0], arr[1]) : arr[0];
            }
        };

        var physics = common.config.settings.gamePhysics.projectiles;

        var limit = randomValue(pData.projectileAmount, true)

        for(var i = 0; i < limit; i++)
        {
            if(p == null)
                p = pData.projectiles[Math.floor(Math.random() * pData.projectiles.length)];

            if(this.projectilePool.available === 0)
                this.projectilePool.expand(1);
            
            var projectile = this.projectilePool.create();
            projectile.init(
                fighter,
                common.config.weapons.images[pImage] || (p.images.length > 0 ? common.config.weapons.images[p.images[Math.floor(Math.random() * p.images.length)]] : null),
                fighter.x + fighter.projectileOffset.x,
                fighter.y + fighter.projectileOffset.y, 
                ((physics.baseSpeed.x * randomValue(p.xSpeed)) * fighter.characterData.range) * fighter.field.direction,
                (physics.baseSpeed.y * randomValue(p.ySpeed)) * fighter.characterData.range,
                physics.gravity * randomValue(p.weight),
                (physics.baseDamage * randomValue(p.damage)) * fighter.characterData.power,
                fighter.y,
                p.bounce,
                p.bounceOffWalls || false,
                p.bounceOffFighters || false,
                p.persistent,
                p.incapacitate,
                p.shockRadius,
                p.particles,
                null,
                null,
                p.flashTint,
                p.shake,
                this.projectileUnderLayer,
                null
            );
            this.projectiles.push(projectile);
            this.holder.addChild(projectile);

            p = null;
            pImage = null;
        }
    }

}